import {
  LEADS_WEBHOOKS,
  LEADS_WEBHOOK_LOGS,
  LEAD_CAMPAIGNS_PERFORMANCE
} from "constants/feature-flags";
import { ADMIN_LEVEL_GROUPS, LEADS_WEBHOOKS_GROUPS } from "constants/staff";

import inSection from "./in-section.util";

const LEADS_SETTINGS_PAGES = [
  { to: "settings/form", label: "Form" },
  { to: "settings/service-interests", label: "Service Interests" },
  { to: "settings/tags", label: "Tags" },
  { to: "settings/notifications", label: "Notifications" },
  { to: "settings/templates", label: "Templates" },
  { to: "settings/template-categories", label: "Template Categories" },
  { to: "settings/locations", label: "Locations" },
  {
    to: "settings/email-branding",
    label: "Email Branding",
    featureFlag: LEAD_CAMPAIGNS_PERFORMANCE
  },
  {
    to: "settings/webhooks/google-ads",
    label: "Google Ads webhook",
    keywords: ["webhooks", "lead forms"],
    featureFlag: LEADS_WEBHOOKS,
    roles: LEADS_WEBHOOKS_GROUPS
  },
  {
    to: "settings/webhooks/logs",
    label: "Webhook logs",
    keywords: ["webhooks", "google ads requests"],
    featureFlag: LEADS_WEBHOOKS,
    roles: LEADS_WEBHOOKS_GROUPS,
    when: ({ flags }) => Boolean(flags[LEADS_WEBHOOK_LOGS])
  }
].map((row) => ({ trail: ["Settings"], roles: ADMIN_LEVEL_GROUPS, ...row }));

export const LEADS_DESTINATIONS = inSection("/leads", [
  { to: "dashboard", label: "Dashboard" },
  { to: "inbox", label: "Inbox" },
  { to: "campaigns", label: "Campaigns" },
  { to: "landing-pages", label: "Landing Pages" },
  { to: "settings", label: "Settings", roles: ADMIN_LEVEL_GROUPS },
  ...LEADS_SETTINGS_PAGES
]);
